import { useQuery } from '../../lib';
import { useTribeClient } from '../../useTribeClient';
import { getAppNetworkSettingsKey } from '../../utils/keys';
export const useAppNetworkSettings = (options) => {
    const { variables, useQueryOptions } = options;
    const { client } = useTribeClient();
    const appNetworkSettingsKey = getAppNetworkSettingsKey(variables);
    return useQuery(appNetworkSettingsKey, () => client.app.networkSettings(variables), useQueryOptions);
};
//# sourceMappingURL=useAppNetworkSettings.js.map